"use client";

import { useIntersectionObserver } from "@uidotdev/usehooks";

import { useEffect, useState, type ReactNode } from "react";

export type LoadMoreFn = (args: { skip: number }) => Promise<unknown>;

type Props = {
  children?: ReactNode | ((props: { loading: boolean }) => ReactNode);
  skip: number;
  total: number;
  onLoadMore: LoadMoreFn;
};

export function InfiniteScroll({ children, skip, total, onLoadMore }: Props) {
  const [ref, entry] = useIntersectionObserver({
    rootMargin: "200px",
  });
  const [loading, setLoading] = useState(false);

  const handleLoading = async () => {
    setLoading(true);
    await onLoadMore({ skip });
    setLoading(false);
  };

  useEffect(() => {
    if (entry?.isIntersecting && skip < total) {
      handleLoading();
    }
  }, [entry?.isIntersecting, total]);

  return (
    <>
      {typeof children === "function" ? children({ loading }) : children}
      <div ref={ref} />
    </>
  );
}
